<template>
  <div class="col-12 col-lg-8 col-xl-9">
    <Loading v-if="showLoading"></Loading>
    <section v-if="errorMessage !== ''" class="col-12 col-lg-8 col-xl-9">
      <div class="alert alert-warning" role="alert">
        {{errorMessage}}
      </div>
    </section>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
export default {
  components: {
    Loading
  },
  name: 'PreContentHeader',
  props: ['showLoading', 'errorMessage']
}
</script>



// WEBPACK FOOTER //
// src/components/PreContentHeader.vue